/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.PatientApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  ProblemDetails,
  RecordClientActivityRequest
} from '../model';

import { customAxios } from '../../custom-axios';
import type { ErrorType } from '../../custom-axios';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Records a flush of the signed-in client's app activity for their practice's client profile: at most 50 entries,
recorded together or refused together with a bad request. The client is the caller's session, never the body.
 */
export const recordClientActivity = (
    recordClientActivityRequest: RecordClientActivityRequest,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/client-activity`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: recordClientActivityRequest, signal
    },
      options);
    }




export const getRecordClientActivityMutationKey = () => ['recordClientActivity'] as const;

export const getRecordClientActivityMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordClientActivity>>, TError,RecordClientActivityMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof recordClientActivity>>, TError,RecordClientActivityMutationVariables, TContext> => {

const mutationKey = getRecordClientActivityMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordClientActivity>>, RecordClientActivityMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  recordClientActivity(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecordClientActivityMutationResult = NonNullable<Awaited<ReturnType<typeof recordClientActivity>>>
    export type RecordClientActivityMutationBody = RecordClientActivityRequest
    export type RecordClientActivityMutationError = ErrorType<ProblemDetails>
    export type RecordClientActivityMutationVariables = {data: RecordClientActivityRequest}

    /**
 * @summary Records a flush of the signed-in client's app activity for their practice's client profile: at most 50 entries,
recorded together or refused together with a bad request. The client is the caller's session, never the body.
 */
export const useRecordClientActivity = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordClientActivity>>, TError,RecordClientActivityMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recordClientActivity>>,
        TError,
        RecordClientActivityMutationVariables,
        TContext
      > => {
      return useMutation(getRecordClientActivityMutationOptions(options), queryClient);
    }
